// extracted by mini-css-extract-plugin
module.exports = {"option":"VarietySelectMobile_option__Kk_d4","speciesName":"VarietySelectMobile_speciesName__1a8hh"};